import Page from "@/components/layout/Page";

export default function NHS() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">NHS</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Testimonials and feedback from NHS professionals using Samboards in healthcare settings.
            </p>
            
            <p className="text-lg leading-relaxed">
              NHS trusts across the UK have adopted Samboards as part of their approach to patient-centred care. Occupational therapists, mental health professionals, and rehabilitation specialists use our products to support patients during treatment, recovery, and therapy sessions.
            </p>
            
            <p className="text-lg leading-relaxed">
              Healthcare professionals value our products for their versatility, durability, and effectiveness in clinical settings. From stroke rehabilitation units to mental health wards, sensory waiting areas to outpatient clinics, Samboards provide calming sensory input that supports patient wellbeing.
            </p>
            
            <p className="text-lg leading-relaxed">
              Clinical staff report that patients engage positively with the tactile sensory boards, finding them helpful for managing anxiety during procedures, supporting sensory retraining after neurological events, and providing comfort during difficult times.
            </p>
            
            <p className="text-lg leading-relaxed">
              The feedback from NHS professionals confirms that sensory tools like Samboards play a valuable role in holistic patient care, complementing clinical interventions and supporting recovery journeys.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
